import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Clinic } from '../../../../shared/state/clinic/clinic.store';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { NavController } from '@ionic/angular';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';

@Component({
    selector: 'app-header-social',
    templateUrl: './header-social.component.html',
    styleUrls: ['./header-social.component.scss'],
})
export class HeaderSocialComponent implements OnInit {
    clinics$: Observable<Clinic[]>;
    showClinicDetails: boolean;
    isPersonalized$: Observable<boolean>;
    @Input() isLoadingContent;

    constructor(
        private settingsQuery: SettingsQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private navCtrl: NavController,
        private clinicDetailService: ClinicDetailService,
        private clinicQuery: ClinicQuery
    ) {}

    ngOnInit(): void {
        this.clinics$ = this.clinicQuery.select('clinicsFound');
        this.showClinicDetails = this.settingsQuery.showClinicDetails;
        this.isPersonalized$ = this.settingsQuery.selectIsPersonalized();
    }

    goBack() {
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.browser ||
            this.settingsQuery.showClinicDetails
        ) {
            this.navCtrl.navigateBack([
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/details',
            ]);
        } else {
            this.clinicDetailService.resetStore();
            this.navCtrl.navigateBack('/');
        }
    }
}
